import { Component } from '@angular/core';
import { AppConfig } from '../../../../../app/app.config';
import { PtLuxonDate } from '../../../../../models/projects/date.models';
import { DateService } from '../../../../../services/date/date.service';
import { NavParams, ViewController } from 'ionic-angular';
import { cloneDeep } from 'lodash';
import { DateLostInTimeResult } from '../../../../../models/time-zones/time-zone.models';
import {
  WeatherLogAdditionalReadingService
} from '../../../../../services/weather-readings/weather-log-additional-reading.service';
import { WeatherLogStandaloneEditor } from '../../../../../models/weather-readings/weather-readings.models';

@Component({
  selector: 'weather-log-add-standalone-reading',
  templateUrl: 'weather-log-add-standalone-reading.html'
})
export class WeatherLogAddStandaloneReadingComponent {
  config = AppConfig.settings;
  dailyLogDate: PtLuxonDate;
  isWeb: boolean;
  standaloneEditor: WeatherLogStandaloneEditor;
  mask: Array<string | RegExp> = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
  saveLoading: boolean;
  readingTimeValid: boolean;
  displayDuplicateTimeErrorMessage: boolean;
  displayDateLostInTimeErrorMessage: boolean;
  lostInTimeResult: DateLostInTimeResult;
  projectId: number;
  vesselId: number;

  constructor(private dateService: DateService,
              public navParams: NavParams,
              public viewController: ViewController,
              private weatherLogAdditionalReadingService: WeatherLogAdditionalReadingService,
  ) {
    this.dailyLogDate = this.navParams.get('dailyLogDate');
    this.projectId = this.navParams.get('projectId');
    this.vesselId = this.navParams.get('vesselId');
    this.isWeb = this.navParams.get('isWeb');
    this.standaloneEditor = new WeatherLogStandaloneEditor();
    this.saveLoading = false;
  }

  regexChange(inputTime: string) {
    if (inputTime.charAt(0) === '2') {
      this.mask[1] = new RegExp('[0-3]');
    } else {
      this.mask[1] = new RegExp('\\d');
    }
  }

  async closeModal(choice: boolean) {
    if (choice) {
      await this.saveStandaloneReading();
    } else {
      await this.viewController.dismiss({choice: false});
    }
  }

  async saveStandaloneReading() {
    this.displayDuplicateTimeErrorMessage = false;
    this.saveLoading = true;

    this.standaloneEditor.readingTimeOffset = this.standaloneEditor.readingTime.dateTime.offset / 60;
    this.standaloneEditor.projectId = this.projectId;
    this.standaloneEditor.dailyLogDate = this.dailyLogDate.dateTime;
    this.standaloneEditor.vesselId = this.vesselId;

    const timeValid = await this.weatherLogAdditionalReadingService.validateTime(cloneDeep(this.standaloneEditor));

    if (!timeValid) {
      this.displayDuplicateTimeErrorMessage = true;
      this.saveLoading = false;
      return;
    }

    await this.weatherLogAdditionalReadingService.saveWeatherLogAdditionalReadingEditor(cloneDeep(this.standaloneEditor));

    await this.viewController.dismiss({choice: true});
  }

  async readingTimeAltered() {
    this.displayDuplicateTimeErrorMessage = false;
    this.readingTimeValid = this.dateService.timeIsValid(this.standaloneEditor.readingTimeShow);

    if (!this.readingTimeValid || this.standaloneEditor.readingTimeShow === '') {
      return;
    }

    this.standaloneEditor.readingTime = await this.dateService
      .setPtLuxonDateFromUserEnteredString(this.standaloneEditor.readingTimeShow, this.dailyLogDate.dateTime, this.standaloneEditor.readingTimeOffset);
    this.standaloneEditor.readingTimeOffset = this.standaloneEditor.readingTime.dateTime.offset / 60;

    this.lostInTimeResult = cloneDeep(this.standaloneEditor.readingTime.isLostInTime);

    if (this.lostInTimeResult && this.lostInTimeResult.result) {
      this.displayDateLostInTimeErrorMessage = true;
    } else {
      this.displayDateLostInTimeErrorMessage = false;
    }
  }

  offsetSelected(offsetSelectedPtDate: PtLuxonDate) {
    this.standaloneEditor.readingTimeOffset = offsetSelectedPtDate.dateTime.offset / 60;
  }
}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-log-manage-readings/components/weather-log-add-standalone-reading/weather-log-add-standalone-reading.ts